import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type SystemNotificationSettings } from "features/Accounts/types";
import { type RootState } from "features/Application/globaltypes/redux";
import { getPrefix } from "features/Application/slices/models";

export interface SystemNotificationSettingsState {
  settings: SystemNotificationSettings;
  isLoading: boolean;
  error: Error | undefined;
}

const initialState: SystemNotificationSettingsState = {
  settings: { notificationTypes: [] },
  isLoading: false,
  error: undefined,
};

export const editSystemNotificationSettingsSlice = createSlice({
  name: getPrefix({
    namespace: ReducerNamespaceTypes.Accounts,
    entity: ReducerEntityPrefixTypes.SystemNotificationSettings,
    name: "edit",
  }),
  initialState,
  reducers: {
    req(state: SystemNotificationSettingsState) {
      state.isLoading = true;
    },
    got(state: SystemNotificationSettingsState, action: PayloadAction<SystemNotificationSettings>) {
      state.isLoading = false;
      state.settings = action.payload;
    },
    err(state: SystemNotificationSettingsState, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { req, got, err } = editSystemNotificationSettingsSlice.actions;

export const systemNotificationSettingsSelector = (state: RootState) => state.accounts.systemNotificationSettings;

export default editSystemNotificationSettingsSlice.reducer;
